<!-- @ts-nocheck -->
<template>
  <q-input
    v-bind="$attrs"
    filled
    :stack-label="!dense"
    :label="getLabel()"
    :placeholder="placeholder"
    :after="after"
    :align="align"
    :rows="rows"
    type="number"
    :ref="name"
    :disable="localdisable"
    :readonly="localdisable"
    :hint="hint"
    :error="error"
    :error-message="errorMessage"
    :dense="dense"
    v-model="localvalue"
    @blur="onblur"
    @focus="onfocus"
    @update:modelValue="onchange"
    style="padding-bottom: 0"
    :mask="mask"
    fill-mask="0"
  >
    <slot v-for="(_, name) in $slots" :name="name" />
    <template v-for="(_, name) in $slots" v-slot:[name]="slotData"
      ><slot :name="name" v-bind="slotData"
    /></template>
  </q-input>
</template>

<script lang="ts">
// @ts-nocheck
import IstFormBase from "./IstFormBase";
import { Emit, Prop, Watch } from "vue-property-decorator";
import { QInput } from "quasar";

export default class App extends IstFormBase {
  name = "IstNumberInput";
  localvalue = 0;
  localdisable = false;

  @Prop()
  validation!: any;
  @Prop({ default: 0, type: [Number, String] })
  modelValue!: any;
  @Prop({ default: false })
  disable!: boolean | string;
  @Prop({ default: false })
  readonly!: boolean | string;
  @Prop({ default: "" })
  placeholder!: string;
  @Prop()
  type!: string;
  @Prop({ default: false })
  focus!: boolean;
  @Prop({ default: "" })
  min!: string;
  @Prop({ default: false, type: [Boolean, String] })
  dense!: boolean | string;
  @Prop({ default: "" })
  max!: string;
  @Prop({ default: "" })
  minLength!: string;
  @Prop({ default: "" })
  maxLength!: string;
  @Prop({ default: "" })
  patternErrorMsg!: string;
  @Prop({ default: "" })
  pattern!: string;
  @Prop({ default: "" })
  rows!: string;
  @Prop({ default: "" })
  align!: string;
  @Prop({ default: undefined })
  hint!: string | undefined;
  @Prop()
  after!: [];
  @Prop({ default: false })
  error!: boolean;
  @Prop()
  errorMessage!: string;

  @Prop()
  mask!: string;

  mounted() {
    if (this.focus) {
      (this.$refs[this.name] as QInput).focus();
    }
    this.localvalue = this.modelValue;
    this.localdisable =
      (typeof this.disable === "boolean" && this.disable) || this.disable == "true";
  }

  @Watch("value")
  onvalue(value) {
    this.localvalue = value;
  }
  @Watch("disable")
  ondisable(value) {
    this.localdisable = value;
  }

  @Emit("blur")
  onblur() {
    this.$emit("blur");
    return;
  }

  @Emit("focus")
  onfocus() {
    this.$emit("focus");
    return;
  }

  @Emit("change")
  @Emit("update:modelValue")
  onchange() {
    this.$emit("change", this.localvalue);
    this.$emit("update:modelValue", this.localvalue);
    return this.localvalue;
  }
}
</script>

<style></style>
